import { useRepositoryQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useCurrentServiceIdContext } from '../../contexts/CurrentServiceIdContext';

export const useGetBaseRateOptions = () => {
    const serviceId = useCurrentServiceIdContext();
    const enterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery(
        'rates',
        'getAll',
        {
            serviceIds: [serviceId],
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ rates }) =>
                rates?.map(({ id, name }) =>
                    createOption({
                        label: name,
                        value: id,
                    })
                ),
        }
    );
};
